import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { todayISO, addDaysISO } from "@/lib/residences";
import DateField from "@/components/residences/DateField";
import GuestPicker from "@/components/residences/GuestPicker";

const field = "w-full bg-white border border-[#EFE6DB] rounded-xl px-3 py-3 text-sm text-[#17252B] outline-none focus:border-[#38B5D8]";
const lab = "text-[11px] font-bold uppercase tracking-wider text-[#71828A] mb-1 block";

export default function ResidenceSearchForm({ meta, initial = {}, onSearch }) {
  const nav = useNavigate();
  const [f, setF] = useState({ city: "", quartier: "", check_in: "", check_out: "", adults: "", children: "", infants: "", type: "", ...initial });
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const setIn = (v) => setF((p) => ({ ...p, check_in: v, check_out: p.check_out && v && p.check_out <= v ? "" : p.check_out }));
  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    const g = Number(f.adults || 0) + Number(f.children || 0);
    Object.entries({ ...f, guests: g > 1 || f.adults ? g : "" }).forEach(([k, v]) => { if (v) p.set(k, v); });
    if (onSearch) onSearch({ ...f, guests: g || "" }); else nav(`/residences/recherche?${p.toString()}`);
  };
  return (
    <form onSubmit={submit} data-testid="residence-search-form" className="bg-white/95 backdrop-blur rounded-3xl p-4 sm:p-5 shadow-[0_20px_60px_rgba(18,59,74,0.18)] grid grid-cols-2 lg:grid-cols-[1.1fr_1.1fr_1fr_1fr_1.2fr_auto] gap-3 items-end">
      <label className="col-span-1"><span className={lab}>Ville</span>
        <select data-testid="rs-city" value={f.city} onChange={set("city")} className={field}>
          <option value="">Toutes</option>
          {(meta?.cities || []).map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}
        </select>
      </label>
      <label className="col-span-1"><span className={lab}>Quartier</span>
        <input data-testid="rs-quartier" value={f.quartier} onChange={set("quartier")} placeholder="Angré, Zone 4…" className={field} />
      </label>
      <label><span className={lab}>Arrivée</span>
        <DateField testid="rs-checkin" min={todayISO()} value={f.check_in} onChange={setIn} />
      </label>
      <label><span className={lab}>Départ</span>
        <DateField testid="rs-checkout" min={f.check_in ? addDaysISO(f.check_in, 1) : todayISO()} value={f.check_out} onChange={(v) => setF((p) => ({ ...p, check_out: v }))} />
      </label>
      <label><span className={lab}>Voyageurs</span>
        <GuestPicker testid="rs-guests" value={{ adults: f.adults || 1, children: f.children || 0, infants: f.infants || 0 }} onChange={(p) => setF((s) => ({ ...s, ...p }))} />
      </label>
      <Button data-testid="rs-submit" type="submit" className="flame-gradient rounded-xl font-bold h-[46px] px-6 col-span-1 lg:col-span-1"><Search className="w-4 h-4 mr-2" />Rechercher</Button>
    </form>
  );
}
